module.exports = __webpack_public_path__ + "img/img26.ca2da80f.png";